(function () {
  function demotePolicyBodyHeadings(root) {
    var scope = root || document;
    var headings = scope.querySelectorAll('.shopify-policy__body h1');

    headings.forEach(function (heading) {
      var replacement = document.createElement('h2');

      Array.prototype.slice.call(heading.attributes).forEach(function (attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });

      replacement.classList.add('chef-policy__demoted-heading');
      while (heading.firstChild) {
        replacement.appendChild(heading.firstChild);
      }
      heading.replaceWith(replacement);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      demotePolicyBodyHeadings(document);
    }, { once: true });
  } else {
    demotePolicyBodyHeadings(document);
  }
})();
